import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { "txt-center": "" }
const _hoisted_2 = {
  key: 0,
  "txt-center": ""
}
const _hoisted_3 = {
  primary: "",
  "f-w-700": ""
}
const _hoisted_4 = { "txt-center": "" }
const _hoisted_5 = { style: {"margin-top":"12px"} }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { "txt-center": "" }
const _hoisted_8 = { "txt-center": "" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_form_title = _resolveComponent("app-form-title")!
  const _component_User = _resolveComponent("User")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_Message = _resolveComponent("Message")!
  const _component_lock = _resolveComponent("lock")!
  const _component_app_password_strength = _resolveComponent("app-password-strength")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_app_form_holder = _resolveComponent("app-form-holder")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_app_form_holder, null, {
      default: _withCtx(() => [
        _createVNode(_component_app_form_title, { title: _ctx.title }, null, 8, ["title"]),
        _createElementVNode("div", _hoisted_1, [
          _cache[11] || (_cache[11] = _createElementVNode("div", { "txt-center": "" }, "Welcome to E4T!", -1)),
          (_ctx.invitation !== undefined && _ctx.invitation.invitedBy !== undefined)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _cache[9] || (_cache[9] = _createElementVNode("span", null, "Thanks for accepting ", -1)),
                _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.invitation.invitedBy.firstName), 1),
                _cache[10] || (_cache[10] = _createElementVNode("span", null, " 's invite — glad you could join us! ", -1))
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", null, [
          (_ctx.keyIsValid !== false)
            ? _withDirectives((_openBlock(), _createBlock(_component_el_form, {
                key: 0,
                rules: _ctx.rules,
                onSubmit: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["prevent"])),
                class: "App-Styled-Form",
                "label-position": 'top',
                "label-width": "100px",
                model: _ctx.form,
                style: {"margin-top":"12px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_row, { gutter: 10 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            prop: "firstName",
                            label: "firstName"
                          }, {
                            label: _withCtx(() => [
                              _createVNode(_component_el_icon, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_User)
                                ]),
                                _: 1
                              }),
                              _cache[12] || (_cache[12] = _createTextVNode(" First Name ", -1))
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                placeholder: "John",
                                modelValue: _ctx.form.firstName,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.firstName) = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            prop: "lastName",
                            label: "lastName"
                          }, {
                            label: _withCtx(() => [
                              _createVNode(_component_el_icon, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_User)
                                ]),
                                _: 1
                              }),
                              _cache[13] || (_cache[13] = _createTextVNode(" Last Name ", -1))
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                placeholder: "Doe",
                                modelValue: _ctx.form.lastName,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.lastName) = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  (_ctx.form.key === undefined)
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 0,
                        prop: "email",
                        label: "Email"
                      }, {
                        label: _withCtx(() => [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_Message)
                            ]),
                            _: 1
                          }),
                          _cache[14] || (_cache[14] = _createTextVNode(" Email ", -1))
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            placeholder: "johndoe@e4t.com",
                            modelValue: _ctx.form.email,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.email) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_tooltip, {
                    placement: "top",
                    content: "\n            Should contain at least one special character, Should contain capital letter, \n            Min 8 characters, Max 35 characters.\n            "
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", null, [
                        _createVNode(_component_el_form_item, {
                          prop: "password",
                          label: "Password"
                        }, {
                          label: _withCtx(() => [
                            _createVNode(_component_el_icon, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_lock)
                              ]),
                              _: 1
                            }),
                            _cache[15] || (_cache[15] = _createTextVNode(" Password ", -1))
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              placeholder: "********",
                              type: "password",
                              modelValue: _ctx.form.password,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.password) = $event)),
                              "show-password": ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_app_password_strength, {
                          password: _ctx.form.password
                        }, null, 8, ["password"])
                      ])
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_el_button, {
                      disabled: 
                (!_ctx.form.email && _ctx.form.key === undefined) ||
                !_ctx.form.password ||
                !_ctx.form.firstName ||
                !_ctx.form.lastName ||
                !_ctx.tickedTerms ||
                !_ctx.tickedPrivacy
              ,
                      "is-block": "",
                      size: "large",
                      type: "primary",
                      icon: "el-icon-right",
                      onClick: _ctx.submit
                    }, {
                      default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                        _createTextVNode(" Create An Account ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["disabled", "onClick"])
                  ]),
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_el_space, {
                      size: 18,
                      fill: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_checkbox, {
                          modelValue: _ctx.tickedTerms,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.tickedTerms) = $event)),
                          size: "small"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("small", null, [
                              _cache[18] || (_cache[18] = _createTextVNode(" By creating an account and using our platform, to agree to our ", -1)),
                              _createVNode(_component_el_link, {
                                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.navigateToTerms('terms-of-service'))),
                                style: {"font-size":"inherit"}
                              }, {
                                default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                                  _createTextVNode(" Terms of Service ", -1)
                                ]))]),
                                _: 1
                              })
                            ])
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createVNode(_component_el_checkbox, {
                          modelValue: _ctx.tickedPrivacy,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.tickedPrivacy) = $event)),
                          size: "small"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("small", null, [
                              _cache[20] || (_cache[20] = _createTextVNode(" Please tick this box to confirm that you have read our ", -1)),
                              _createVNode(_component_el_link, {
                                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.navigateToTerms('privacy-policy'))),
                                style: {"font-size":"inherit"}
                              }, {
                                default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                                  _createTextVNode(" privacy policy terms ", -1)
                                ]))]),
                                _: 1
                              }),
                              _cache[21] || (_cache[21] = _createTextVNode(" which describes how we use personal data ", -1))
                            ])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }, 8, ["rules", "model"])), [
                [_directive_loading, _ctx.loading]
              ])
            : (_ctx.keyIsValid === false)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createVNode(_component_el_divider),
                  _createVNode(_component_el_empty, { image: _ctx.img }, {
                    description: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                      _createElementVNode("h3", { "m-tb-0": "" }, "Oops, Invalid Link!", -1),
                      _createElementVNode("p", null, [
                        _createTextVNode(" The link used is expired or invalid, "),
                        _createElementVNode("br"),
                        _createTextVNode(" where did you get it from? ")
                      ], -1)
                    ]))]),
                    default: _withCtx(() => [
                      _createVNode(_component_router_link, { to: "/login" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_button, {
                            "is-borderless": "",
                            plain: "",
                            type: "primary",
                            icon: "el-arrow-right"
                          }, {
                            default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                              _createTextVNode(" Sign In ", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["image"])
                ]))
              : _createCommentVNode("", true)
        ]),
        _createVNode(_component_el_divider),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_el_space, {
            "w-100": "",
            fill: true,
            alignment: "center",
            direction: "vertical",
            size: 4
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_row, {
                align: "middle",
                justify: "center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, null, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_8, [
                        _cache[25] || (_cache[25] = _createTextVNode(" Have an account? ", -1)),
                        _createVNode(_component_router_link, { to: "/login" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_link, { type: "primary" }, {
                              default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                                _createTextVNode(" Sign In", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _cache[26] || (_cache[26] = _createTextVNode("! ", -1))
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_row, {
                align: "middle",
                justify: "center"
              }, {
                default: _withCtx(() => [
                  (_ctx.asTalent)
                    ? (_openBlock(), _createBlock(_component_el_col, {
                        key: 0,
                        "txt-center": "",
                        span: 24
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_router_link, { to: "/signup/founder" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_link, null, {
                                default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                                  _createTextVNode(" Join as a founder ", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_el_col, {
                        key: 1,
                        "txt-center": "",
                        span: 24
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_link, null, {
                            default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                              _createTextVNode("Talents Get Invited ?", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    })
  ]))
}